import { memo } from 'react';
import { getGridWorldDimensions } from '../utils/gridWorldGeometry';
import { buildBattleEffectPathData } from '../utils/battleEffectGeometry';

const EFFECT_DEFAULTS = {
  fog: { fill: '#9fb3c8', stroke: '#c9d7e8', opacity: 0.45 },
  ice: { fill: '#9ad8ff', stroke: '#7fd3ff', opacity: 0.42 },
  fire: { fill: '#ffb38a', stroke: '#ff9b6b', opacity: 0.4 },
  acid: { fill: '#b6e673', stroke: '#8bbf47', opacity: 0.36 },
};

const clampOpacity = (value, fallback) => {
  const opacity = Number(value);
  return Number.isFinite(opacity) ? Math.min(0.9, Math.max(0.05, opacity)) : fallback;
};

const GridBattleEffectsCanvas = memo(function GridBattleEffectsCanvas({
  effects = [],
  gridCols,
  gridRows,
  gridType,
}) {
  const world = getGridWorldDimensions(gridCols, gridRows, gridType);

  return (
    <svg
      className='battle_effect_canvas'
      viewBox={`0 0 ${world.width} ${world.height}`}
      preserveAspectRatio='none'
      aria-hidden='true'
    >
      {effects.map((effect) => {
        const defaults = EFFECT_DEFAULTS[effect.kind] || EFFECT_DEFAULTS.fog;
        const fill = effect.color || defaults.fill;
        const stroke = effect.stroke || defaults.stroke || fill;
        const pathData = buildBattleEffectPathData(effect.cells, gridType);
        if (!pathData) return null;
        return (
          <g
            key={effect.id}
            fill={fill}
            stroke={stroke}
            strokeWidth='1'
            strokeDasharray='3 3'
            opacity={clampOpacity(effect.opacity, defaults.opacity)}
          >
            <path d={pathData} vectorEffect='non-scaling-stroke' />
          </g>
        );
      })}
    </svg>
  );
});

export default GridBattleEffectsCanvas;